export const localesOptions: Record<string, string> = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  nl: 'Nederlands',
  it: 'Italiano',
  pl: 'Polski',
  fi: 'Suomi',
  da: 'Dansk',
  sv: 'Svenska',
  pt: 'Português',
  ro: 'Română',
  hu: 'Magyar',
  bg: 'Български',
  et: 'Eesti',
  hr: 'Hrvatski',
  lt: 'Lietuvių',
  lv: 'Latviešu',
};

export const getSafeLanguage = (i18n: any) => {
  if (!i18n || typeof i18n.language !== 'string') {
    return 'en';
  }

  const baseLang = i18n.language.split('-')[0];

  return baseLang.length === 2 ? baseLang : 'en';
};
